import React from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';

const navItems = [
  { path: '/dashboard', label: 'Overview' },
  { path: '/dashboard', label: 'Users' },
  { path: '/dashboard', label: 'Applications' }
];

const DashboardLayout = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-slate-950 text-slate-100 pt-4">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <header className="mb-8 flex flex-col gap-4 rounded-3xl border border-slate-800 bg-slate-900/80 p-6 shadow-glow backdrop-blur-xl">
          <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
            <div>
              <p className="text-cyan-300 uppercase tracking-[0.24em]">Dashboard</p>
              <h1 className="text-3xl font-semibold text-white">Welcome back, {user?.displayName || user?.email}</h1>
              <p className="mt-2 text-slate-400">Review metrics, manage users, and monitor enterprise performance in one place.</p>
            </div>
            <button
              type="button"
              onClick={logout}
              className="rounded-full bg-slate-800 px-4 py-2 text-sm font-semibold text-cyan-200 transition hover:bg-cyan-500/20"
            >
              Sign out
            </button>
          </div>
          <nav className="flex flex-wrap gap-3">
            {navItems.map((item) => (
              <NavLink
                key={item.label}
                to={item.path}
                className={({ isActive }) => `rounded-2xl border border-slate-800 px-4 py-2 text-sm transition ${isActive ? 'bg-cyan-400 text-slate-950' : 'text-slate-300 hover:bg-slate-800'}`}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </header>
        <Outlet />
      </div>
    </div>
  );
};

export default DashboardLayout;
